import type { CountryCode } from "@/config/country-config";

export type CurrencyCode = "SEK" | "EUR" | "NOK";

export type CurrencySettings = {
	country: CountryCode;
	code: CurrencyCode;
	intlLocale: string;
	/** Short suffix for compact display, e.g. in input fields. */
	suffix: string;
};

const currencySettingsByCountry: Record<CountryCode, CurrencySettings> = {
	SE: {
		country: "SE",
		code: "SEK",
		intlLocale: "sv-SE",
		suffix: "kr",
	},
	FI: {
		country: "FI",
		code: "EUR",
		intlLocale: "fi-FI",
		suffix: "€",
	},
	NO: {
		country: "NO",
		code: "NOK",
		intlLocale: "nb-NO",
		suffix: "kr",
	},
};

export const getCurrencySettings = (country: CountryCode): CurrencySettings =>
	currencySettingsByCountry[country];
